import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../assets/css/Navbar.css';

const Navbar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const location = useLocation();

  const handleNavLinkClick = () => {
    setIsNavCollapsed(true);
  };

  const handleNavbarToggle = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };

  return (
    <nav className="navbar navbar-expand-lg fixed-top talatonakids-navbar">
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={handleNavLinkClick}>
          <img 
            src={require('../assets/img/logo-v2.png')} 
            alt="Talatona Kids Logo" 
            className="navbar-logo"
          />
        </Link>

        <button 
          className={`navbar-toggler ${!isNavCollapsed ? 'collapsed' : ''}`}
          type="button" 
          onClick={handleNavbarToggle}
          aria-expanded={!isNavCollapsed}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse bg-brand ${!isNavCollapsed ? 'show' : ''}`} id="main-navbar">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/offer' ? 'active' : ''}`} 
                to="/offer"
                onClick={handleNavLinkClick}
              >
                Oferta Educativa
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/pre-registration' ? 'active' : ''}`} 
                to="/pre-registration"
                onClick={handleNavLinkClick}
              >
                Pré-inscrição
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/gallery' ? 'active' : ''}`} 
                to="/gallery"
                onClick={handleNavLinkClick}
              >
                Galeria
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/contacts' ? 'active' : ''}`} 
                to="/contacts"
                onClick={handleNavLinkClick}
              >
                Contactos
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
